module.exports = __webpack_public_path__ + "img/logo_info.d8af1484.svg";